import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';
import FaChevronLeft from 'react-icons/lib/fa/chevron-left';
import VideoPlayer from '../../../components/videoPlayer';

@observer
class LessonVideoPreviewDrawer extends Component {
    render() {
        const {closePreview, src} = this.props;
        return (
            <div className="lesson-recorder">
                <div className="lesson-recorder-close" onClick={closePreview}>
                    <FaChevronLeft className="recorder-close-icon"/>
                    <FormattedMessage id="general.back"/>
                </div>
                <div className="lesson-recorder-wrapper">
                    <div className="lesson-video-placeholder">
                        <VideoPlayer url={src}/>
                    </div>
                </div>
            </div>
        );
    }
}

LessonVideoPreviewDrawer.propTypes = {
    closePreview: PropTypes.func,
    src: PropTypes.string
};

export default LessonVideoPreviewDrawer;
